import { useEffect, useState } from "react";
import * as authApi from "../../api/auth";
import { AuthCard } from "./AuthCard";

type State = "working" | "done" | "failed";

/** Opened from the link in the confirmation email: spends the token once, then says how it went. */
export function VerifyEmailScreen({ token }: { token: string }) {
  const [state, setState] = useState<State>(token ? "working" : "failed");
  const [message, setMessage] = useState(token ? "" : "This link is incomplete. Request a new one from the sign-in page.");

  useEffect(() => {
    if (!token) return;
    let live = true;
    authApi.verifyEmail(token)
      .then(() => { if (live) setState("done"); })
      .catch((e: Error) => { if (live) { setState("failed"); setMessage(e.message); } });
    return () => { live = false; };
  }, [token]);

  return (
    <AuthCard>
      <h1>Confirm email</h1>
      {state === "working" && <div className="sub" data-testid="verify-working">Confirming your email address…</div>}
      {state === "done" && <div className="sub" data-testid="verify-done">Your email address is confirmed. You can sign in now.</div>}
      {state === "failed" && <div className="error-text" role="alert" data-testid="verify-failed">{message}</div>}
      <a className="btn primary" href="#/login" data-testid="to-login" style={{ textAlign: "center" }}>Go to sign in</a>
    </AuthCard>
  );
}
